import { render, staticRenderFns } from "./RentalTnCModal.vue?vue&type=template&id=b06c9dfc&scoped=true"
var script = {}
import style0 from "./RentalTnCModal.vue?vue&type=style&index=0&id=b06c9dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06c9dfc",
  null
  
)

export default component.exports